export default __webpack_public_path__ + "static/media/pro-elevate-gry-2.e9865597.png";